import { isPast } from 'date-fns';

import { OrganizationAPIKey } from '@/shared/api/protocol-ts/api/auth/dto_auth_pb';

export const isApiKeyExpired = (apiKey: OrganizationAPIKey): boolean =>
  !!apiKey.ExpiresAt && isPast(apiKey.ExpiresAt.toDate());
